<template>
  <v-card width="500">
    <v-system-bar color="danger">
      Meldung häufiger Absenzen <v-spacer />{{ this.items.length }}
    </v-system-bar>

    <template v-for="item in groups">
      <v-system-bar :key="item.date">
        <DateValue long :value="item.date" />
      </v-system-bar>
      <PersonItemBasic
        :to="{ name: 'PersonAbsences', params: { id: entry.student.id } }"
        :value="{
          ...entry.student,
          description: 'Meldung von ' + entry.teacher.code,
        }"
        clickable
        v-for="entry in item.entries"
        :key="entry.id"
      >
        <div class="d-flex flex-column w-full">
          <div class="d-flex justify-end">
            Entscheid AL
            <v-simple-checkbox
              class="ml-2"
              :value="entry.resolution != null"
              disabled
            ></v-simple-checkbox>
          </div>
          <div class="d-flex justify-end">
            E-Mail-Versand
            <v-simple-checkbox
              class="ml-2"
              :value="entry.emailSent"
              disabled
            ></v-simple-checkbox>
          </div>
        </div>
      </PersonItemBasic>
    </template>
    <v-divider></v-divider>
    <v-card-actions
      ><v-btn block text :to="{ name: 'Absences' }"
        >alle anzeigen</v-btn
      ></v-card-actions
    >
  </v-card>
</template>
<script>
import { defineComponent } from "vue";
import DateValue from "common/components/DateValue.vue";
import PersonItemBasic from "common/components/PersonItemBasic.vue";

export default defineComponent({
  name: "FrequentAbsences",
  components: { PersonItemBasic, DateValue },
  props: ["items"],
  data() {
    return { groups: [] };
  },
  watch: {
    items() {
      this.items
        .filter(
          (el) =>
            el.student.schoolClass &&
            el.student.schoolClass.division.id ==
              this.$_profilePerson.division.id
        )
        .forEach((item) => {
          let group = this.groups.find((i) => i.date === item.applicationDate);
          if (group) {
            group.entries.push(item);
          } else {
            this.groups.push({ date: item.applicationDate, entries: [item] });
          }
        });
      this.groups = this.groups.sort((a, b) =>
        a.date > b.date ? 1 : b.date > a.date ? -1 : 0
      );
    },
  },
});
</script>
